import { render } from "./CategoryModal.vue?vue&type=template&id=eff340a2&scoped=true"
import script from "./CategoryModal.vue?vue&type=script&lang=js"
export * from "./CategoryModal.vue?vue&type=script&lang=js"

import "./CategoryModal.vue?vue&type=style&index=0&id=eff340a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eff340a2"]])

export default __exports__